import {
  Client,
  cacheExchange,
  fetchExchange,
  debugExchange,
  mapExchange,
} from "@urql/svelte"
import { trackFunction } from "./tracking";

const errorExchange = mapExchange({
  onError({ graphQLErrors, networkError }) {
    if (graphQLErrors)
      graphQLErrors.forEach(({ message, extensions: { problems = [] } = {} }) => {
        const issues = (problems as Array<{ explanation: string }>).map((p) => p.explanation).join("\n")
        trackFunction({
          entity: "error",
          action: "encountered",
          type: "system_exception",
          details: `[GraphQL error]: ${message}\n${issues}`,
        })
      })

    if (networkError) trackFunction({
      entity: "error",
      action: "encountered",
      type: "system_exception",
      details: `[${networkError.name}]: ${networkError.message}`,
    })
  },
});

export function getUrqlClient({ host, locale }: { host: string, locale: string }) {
  return new Client({
    url: `${host}/lead_conversion_flows/graphql`,
    exchanges: [debugExchange, errorExchange, cacheExchange, fetchExchange],
    fetchOptions: () => {
      return {
        headers: {
          "Accept-Language": locale,
        },
      }
    },
  })
}
